<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('public.research_service.title')  }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="middle_loc">{{ $t('public.title')  }} > </span>
            <span class="middle_loc">{{ $t('public.research_service.title')  }} > </span>
            <span class="back_loc">{{ $t('common.button.add') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type2">
            <v-flex class="active step_box step02">
              <h2>{{ $t('public.research_service.fields.step_01') }}</h2>
              <p>{{ $t('public.research_service.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('public.research_service.fields.step_02') }}</h2>
              <p>{{ $t('public.research_service.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="step_box step04">
              <h2>{{ $t('public.research_service.fields.step_03') }}</h2>
              <p>{{ $t('public.research_service.fields.payment') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="pt-20 fd_column">
            <v-row>
              <v-col cols="12">
                <h2 class="m_title solo">{{ $t('public.research_service.fields.request_information') }}</h2>
                <v-row class="table_data ma-0" style="border-bottom: 1px solid #eee;">
                  <v-col cols="2" class="title request_data_name">{{ $t('public.research_service.fields.receipt_no') }}</v-col>
                  <v-col cols="10" class="content request_data_value">{{ receipt_no }}</v-col>
                </v-row>
                <v-row class="table_data ma-0" style="border-bottom: 1px solid #eee;">
                  <v-col cols="2" class="title request_data_name">{{ $t('public.research_service.fields.requests_service') }}</v-col>
                  <v-col cols="10" class="content request_data_value">{{ $vuetify.rtl ? applicant.service_name_ar : applicant.service_name_en }}</v-col>
                </v-row>
                <v-row class="table_data ma-0" style="border-bottom: 1px solid #eee;">
                  <v-col cols="2" class="title request_data_name">{{ $t('public.research_service.fields.name') }}</v-col>
                  <v-col cols="10" class="content request_data_value">{{ $vuetify.rtl ? applicant.name_ar : applicant.name_en }}</v-col>
                </v-row>
                <v-row class="table_data ma-0" style="border-bottom: 1px solid #eee;">
                  <v-col cols="2" class="title request_data_name">{{ $t('public.research_service.fields.company') }}</v-col>
                  <v-col cols="10" class="content request_data_value">{{ fnGetCompanyName($vuetify.rtl) }}</v-col>
                </v-row>
                <v-row class="table_data ma-0" style="border-bottom: 1px solid #eee;">
                  <v-col cols="2" class="title request_data_name">{{ $t('public.research_service.fields.address') }}</v-col>
                  <v-col cols="10" class="content request_data_value">{{ $vuetify.rtl ? applicant.address_ar : applicant.address_en }}</v-col>
                </v-row>
                <v-row class="table_data ma-0" style="border-bottom: 1px solid #eee;">
                  <v-col cols="2" class="title request_data_name">{{ $t('public.research_service.fields.tel') }}</v-col>
                  <v-col cols="10" class="content request_data_value">{{ applicant.telephone }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-layout>
          <v-layout class="inner_contents mt-30" column>
            <ValidationObserver ref="researchService1">
              <v-flex class="item_box bd_none pa-0">
                <h2 class="m_title"><i>*</i> {{ $t('public.research_service.fields.research_types') }}</h2>
                <div class="input_checkbox_type_basic row ma-0 pa-15 pb-0">
                  <ValidationProvider v-slot="{ errors }" :name="$t('public.research_service.fields.research_types')" :rules="{required: true}">
                    <v-radio-group
                      v-model="research.research_type_code"
                      :error-messages="errors"
                    >
                      <template v-for="(item, index) in $vuetify.rtl ? researchTypeListAr : researchTypeListEn">
                        <v-tooltip top :key="index" max-width="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-radio
                              color="#a01c2a"
                              :value="item.value"
                              style="height:30px;"
                              :key="index"
                              v-on="on"
                            >
                              <template v-slot:label>
                                <div v-on="on" v-bind="attrs">{{item.text}}</div>
                              </template>
                            </v-radio>
                          </template>
                          <span class="ft-size12" v-if="item.value === '5801'">{{$t('public.research_service.fields.research_type_msg_01')}}</span>
                          <span class="ft-size12" v-if="item.value === '5802'">{{$t('public.research_service.fields.research_type_msg_02')}}</span>
                          <span class="ft-size12" v-if="item.value === '5803'">{{$t('public.research_service.fields.research_type_msg_03')}}</span>
                          <span class="ft-size12" v-if="item.value === '5804'">{{$t('public.research_service.fields.research_type_msg_04')}}</span>
                          <span class="ft-size12" v-if="item.value === '5805'">{{$t('public.research_service.fields.research_type_msg_05')}}</span>
                          <span class="ft-size12" v-if="item.value === '5806'">{{$t('public.research_service.fields.research_type_msg_06')}}</span>
                          <span class="ft-size12" v-if="item.value === '5807'">{{$t('public.research_service.fields.research_type_msg_07')}}</span>
                        </v-tooltip>
                      </template>
                    </v-radio-group>
                  </ValidationProvider>
                </div>

                <v-flex class="item_box bd_none pa-20 pt-0" v-if="research.research_type_code === '5807'">
                  <h2 class="nec_title">{{ $t('public.research_service.fields.attachment_of_id') }}</h2>
                  <div class="input_text_type_basic file_type wp50 mt-10 fileForm">
                    <ValidationProvider v-slot="{ errors }" :name="$t('public.research_service.fields.attachment_of_id')"
                      :rules="{required: research.research_type_code === '5807' && research.id_card_file_key === ''}">
                      <v-file-input
                        :placeholder="research.id_card_file_name ? research.id_card_file_name : $t('common.common.no_files_selected')"
                        outlined
                        dense
                        :prepend-icon="$t('common.common.select_file')"
                        class="ft-size12 br_none wp100"
                        v-model="idCardFile"
                        style="height: 40px;"
                        accept=".pdf, .jpg, .gif"
                        :error-messages="errors"
                        @change="fnUploadIdCardFile()"
                        clearable
                        @click:clear="fnInitIdCardFile()"
                        :append-icon="research.id_card_file_name ? '$clear': ''"
                        @click:append="fnInitIdCardFile()"
                      >
                      </v-file-input>
                    </ValidationProvider>
                  </div>
                </v-flex>
              </v-flex>

              <v-flex class="item_box bd_none pa-0">
                <div class="data_table_html_type pa-15 pt-0 pb-10">
                  <ValidationProvider v-slot="{ errors }" :name="$t('public.research_service.fields.comment')" :rules="{required: true, max: 200}">
                    <v-textarea
                      outlined
                      :placeholder="$t('public.research_service.fields.comment')"
                      counter
                      :counter-value="fnValidateComment"
                      class="br_none mt-15 text_icon_type ie_textarea login_text_field"
                      width="100%"
                      v-model="research.notes"
                      :error-messages="errors"
                    >
                    </v-textarea>
                  </ValidationProvider>
                </div>
              </v-flex>

              <v-flex class="item_box bd_none pa-0">
                <h2 class="m_title"><i>*</i> {{ $t('public.research_service.fields.search_scope') }}</h2>
                <ValidationProvider v-slot="{ errors }" :name="$t('public.research_service.fields.search_scope')" :rules="{required: true}">
                  <div class="input_checkbox_type_basic row ma-0 pa-15 pb-0">
                    <v-checkbox
                      color="#a01c2a"
                      :label="$t('public.research_service.fields.egyptian_patents')"
                      v-model="indSearch"
                      value="ind_search_egyptian"
                      :error-messages="errors"
                    ></v-checkbox>
                    <v-spacer class="hidden_lr5" />
                    <v-checkbox
                      color="#a01c2a"
                      :label="$t('public.research_service.fields.foreign_patents')"
                      v-model="indSearch"
                      value="ind_search_foreign"
                      :error-messages="errors"
                      hide-details
                    ></v-checkbox>
                  </div>
                </ValidationProvider>
                <div class="pa-20 pb-0" style="border-bottom:1px solid #ddd;">
                  <p class="ft-size12">{{ $t('public.research_service.fields.notice_comment_0') }}</p>
                </div>
              </v-flex>
            </ValidationObserver>


            <ValidationObserver ref="patentInfo">
              <v-flex class="item_box d-flex pb-0 pt-0 mt-0 bd_none">
                <div class="input_text_type_basic">
                  <v-row>
                    <v-col cols="5">
                      <ValidationProvider v-slot="{ errors }" :name="$t('public.research_service.fields.patent_number')" :rules="{required: true}">
                        <v-text-field
                          dense
                          outlined
                          clearable
                          class="ft-size12"
                          style="height:40px;"
                          :placeholder="$t('public.research_service.fields.enter_patent_number')"
                          v-model="patentNumber"
                          :error-messages="errors"
                          ref="patent_number"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="5">
                      <ValidationProvider v-slot="{ errors }" :name="$t('public.research_service.fields.country')" :rules="{required: true}">
                        <v-select
                          dense
                          outlined
                          class="ft-size12"
                          style="height:40px;"
                          :placeholder="$t('public.research_service.fields.select_country')"
                          v-model="countryCode"
                          :items="$vuetify.rtl ? countryArList : countryEnList"
                          :error-messages="errors"
                          ref="country"
                        >
                        </v-select>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                        icon
                        small
                        class="align-center align-self-center"
                        @click="fnAddPatent()">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-flex>
            </ValidationObserver>

            <ValidationObserver ref="researchService2">
              <v-flex class="item_box d-flex bd_none pa-20 pt-0">
                <template v-for="(item, index) in research.research_digital_patents">
                  <v-chip
                    outlined
                    label
                    close
                    dark
                    color="#555"
                    :key="index"
                    @click:close="fnDelPatent(index)"
                  >{{ item.patent_no + ' (' + item.country_code + ')' }}</v-chip>
                  <v-spacer class="hidden_lr5" :key="index+'_spc'"></v-spacer>
                </template>
              </v-flex>

              <v-flex class="item_box bd_none pa-20 pt-0">
                <h2 class="nec_title">{{ $t('public.research_service.fields.notice_comment_2') }}</h2>
                <div class="input_text_type_basic file_type wp50 mt-10 fileForm">
                  <v-file-input
                    solo
                    flat
                    dense
                    outlined
                    accept=".doc, .docx"
                    :placeholder="research.digital_doc_file_name ? research.digital_doc_file_name : $t('public.research_service.fields.no_files_selected')"
                    :prepend-icon="$t('common.common.select_file')"
                    class="ft-size12"
                    style="height: 40px;"
                    v-model="digitalDocFile"
                    @change="fnUploadDigitalFile()"
                    clearable
                    @click:clear="fnInitDigitalFile()"
                    :append-icon="research.digital_doc_file_name ? '$clear': ''"
                    @click:append="fnInitDigitalFile()"
                  >
                  </v-file-input>
                </div>
              </v-flex>

              <v-flex class="item_box bd_none pa-0">
                <h2 class="m_title">{{ $t('public.research_service.fields.required_research_language') }}</h2>
                <div class="input_checkbox_type_basic row ma-0 pa-20 pt-0">
                  <ValidationProvider v-slot="{ errors }" :name="$t('public.research_service.fields.required_research_language')" :rules="{required: false}">
                    <span class="row">
                      <v-checkbox
                        :label="$t('public.research_service.fields.arabic')"
                        v-model="indLang"
                        value="ind_lang_arabic"
                        color="#a01c2a"
                        :error-messages="errors"
                        hide-details
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                      <v-checkbox
                        :label="$t('public.research_service.fields.english')"
                        v-model="indLang"
                        value="ind_lang_english"
                        hide-details
                        color="#a01c2a"
                        :error-messages="errors"
                      ></v-checkbox>
                      <v-spacer class="hidden_lr5"></v-spacer>
                    </span>
                  </ValidationProvider>
                </div>
              </v-flex>
              <v-flex class="item_box pa-0">
                <h2 class="m_title"><i>*</i> {{ $t('public.research_service.fields.the_purpose_of_the_research') }}</h2>
                <div class="input_checkbox_type_basic ma-0 pa-20">
                  <ValidationProvider v-slot="{ errors }" :name="$t('public.research_service.fields.the_purpose_of_the_research')" :rules="{required: true}">
                    <v-checkbox
                      :label="$t('public.research_service.fields.purpose_0')"
                      v-model="indPurpose"
                      value="ind_to_start"
                      color="#a01c2a"
                      :error-messages="errors"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      :label="$t('public.research_service.fields.purpose_1')"
                      v-model="indPurpose"
                      value="ind_scientific_dissertation"
                      color="#a01c2a"
                      :error-messages="errors"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      :label="$t('public.research_service.fields.purpose_2')"
                      v-model="indPurpose"
                      value="ind_solve_tech_problem"
                      color="#a01c2a"
                      :error-messages="errors"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      :label="$t('public.research_service.fields.purpose_3')"
                      v-model="indPurpose"
                      value="ind_feasibility_study"
                      color="#a01c2a"
                      :error-messages="errors"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      :label="$t('public.research_service.fields.purpose_4')"
                      v-model="indPurpose"
                      value="ind_other"
                      color="#a01c2a"
                      :error-messages="errors"
                    ></v-checkbox>
                  </ValidationProvider>
                  <div class="input_text_type_basic mt-10" v-show="research.ind_other == 'Y'">
                    <v-text-field
                      :placeholder="$t('public.research_service.fields.enter_the_purpose_of_the_research')"
                      v-model="research.other_purpose"
                      dense
                      outlined
                      clearable
                      class="ft-size12"
                      counter
                      maxlength="500"
                    >
                    </v-text-field>
                  </div>
                </div>
              </v-flex>
            </ValidationObserver>
          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnNext()"
              >{{ $t('common.button.next') }}</v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'ResearchServiceStep1',
  components :{
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      MobileBreakPoint:0,
      headerTxt : {
        prefix : 'public.research_service.fields.',
        txt : ['#','english','' ]
      },
      headers: [
        { text: '#', align: 'center', value: '', sortable: false, width: 80},
        { text: this.$t('public.research_service.fields.english'), align: 'center', value: '',sortable: false},
        { text: '', align: 'center', value: '',sortable: false, width: 150}
      ],

      researchTypeListAr: [],
      researchTypeListEn: [],
      periodTypeListAr: [],
      periodTypeListEn: [],

      receipt_no : this.$route.params.receipt_no,

      applicant : {
        receipt_no : '',
        request_service_code : '',
        service_name_ar : '',
        service_name_en : '',
        name_ar : '',
        name_en : '',
        company_name_ar : '',
        company_name_en : '',
        address_ar : '',
        address_en : '',
        telephone : ''
      },

      research : {
        company_name_ar : '',
        research_type_code : '',
        ind_search_egyptian : 'N',
        ind_search_foreign : 'N',
        digital_doc_file_key : '',
        digital_doc_file_name : '',
        ind_lang_arabic: 'N',
        ind_lang_english : 'N',
        ind_lang_french : 'N',
        ind_lang_german : 'N',
        ind_lang_other : 'N',
        other_language : '',
        search_period_type_code : '',
        ind_to_start : 'N',
        ind_scientific_dissertation : 'N',
        ind_solve_tech_problem : 'N',
        ind_feasibility_study : 'N',
        ind_other : 'N',
        other_purpose : '',
        notes: '',
        research_digital_patents : [],
        id_card_file_key: '',
        id_card_file_name: ''
      },
      patentNumber : '',
      countryCode : '',
      countryArList : [],
      countryEnList : [],

      idCardFile: null,
      digitalDocFile : null,

      companyModYn : false,

      attachDocList : [],
      indSearch: [],
      indLang: [],
      indPurpose: []
    }
  },
  watch: {
    indLang(val) {
      if (val) {
        this.research.ind_lang_arabic = 'N'
        this.research.ind_lang_english = 'N'
        this.research.ind_lang_french = 'N'
        this.research.ind_lang_german = 'N'
        this.research.ind_lang_other = 'N'

        val.forEach(item => {
          switch(item) {
            case 'ind_lang_arabic':
              this.research.ind_lang_arabic = 'Y'
              break
            case 'ind_lang_english':
              this.research.ind_lang_english = 'Y'
              break
            case 'ind_lang_french':
              this.research.ind_lang_french = 'Y'
              break
            case 'ind_lang_german':
              this.research.ind_lang_german = 'Y'
              break
            case 'ind_lang_other':
              this.research.ind_lang_other = 'Y'
              break
          }
        })
      }
    },
    indSearch(val) {
      if (val) {
        this.research.ind_search_egyptian = 'N'
        this.research.ind_search_foreign = 'N'
        val.forEach(item => {
          if (item === 'ind_search_egyptian') {
            this.research.ind_search_egyptian = 'Y'
          } else if (item === 'ind_search_foreign') {
            this.research.ind_search_foreign = 'Y'
          }
        })
      }
    },
    indPurpose(val){
      if (val) {
        this.research.ind_to_start = 'N'
        this.research.ind_scientific_dissertation = 'N'
        this.research.ind_solve_tech_problem = 'N'
        this.research.ind_feasibility_study = 'N'
        this.research.ind_other = 'N'

        val.forEach(item => {
          switch(item) {
            case 'ind_to_start':
              this.research.ind_to_start = 'Y'
              break
            case 'ind_scientific_dissertation':
              this.research.ind_scientific_dissertation = 'Y'
              break
            case 'ind_solve_tech_problem':
              this.research.ind_solve_tech_problem = 'Y'
              break
            case 'ind_feasibility_study':
              this.research.ind_feasibility_study = 'Y'
              break
            case 'ind_other':
              this.research.ind_other = 'Y'
              break
          }
        })

        if(this.research.ind_other != 'Y'){
          this.research.other_purpose = ''
        }
      }
    },
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetReceipt()
    this.fnInit()
  },
  methods: {
    fnInit(){
      utils.fnGetCountryList('en').then(list => {
        this.countryEnList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      utils.fnGetCountryList('ar').then(list => {
        this.countryArList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      let options = {
        upper_code: '5800'
      }
      utils.fnGetCodeList(options).then(list => {
        this.researchTypeListAr = list.ar
        this.researchTypeListEn = list.en
      })

      options = {
        upper_code: '5900'
      }
      utils.fnGetCodeList(options).then(list => {
        this.periodTypeListAr = list.ar
        this.periodTypeListEn = list.en
      })

      this.fnGetUserInfo()
    },
    fnGetUserInfo(){
      //사용자 프로필 조회
      requestApi({
        url: '/users/profile',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.user_type_code == '2704'){
              this.companyModYn = true
            }

            this.fnGetRequestInfo()
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetUserInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetRequestInfo(){
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/before',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicant.receipt_no           = res.data.receipt_no
            this.applicant.request_service_code = res.data.request_service_code
            this.applicant.service_name_ar      = res.data.service_name_ar
            this.applicant.service_name_en      = res.data.service_name_en
            this.applicant.name_ar              = res.data.name_ar
            this.applicant.name_en              = res.data.name_en
            this.applicant.company_name_ar      = res.data.company_name_ar
            this.applicant.company_name_en      = res.data.company_name_en
            this.applicant.address_ar           = res.data.address_ar
            this.applicant.address_en           = res.data.address_en
            this.applicant.telephone            = res.data.telephone

            this.fnGetResearchService()

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRequestInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetResearchService(){
      requestApi({
        url: '/receivings/research/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.research.company_name_en             = res.data.company_name_en
            this.research.company_name_ar             = res.data.company_name_ar
            this.research.ind_search_egyptian         = res.data.ind_search_egyptian
            this.research.ind_search_foreign          = res.data.ind_search_foreign
            this.research.digital_doc_file_key        = res.data.digital_doc_file_key
            this.research.digital_doc_file_name       = res.data.digital_doc_file_name
            this.research.ind_lang_arabic = res.data.ind_lang_arabic
            this.research.ind_lang_english            = res.data.ind_lang_english
            this.research.ind_lang_french             = res.data.ind_lang_french
            this.research.ind_lang_german             = res.data.ind_lang_german
            this.research.ind_lang_other              = res.data.ind_lang_other
            this.research.other_language              = res.data.other_language
            this.research.ind_to_start                = res.data.ind_to_start
            this.research.ind_scientific_dissertation = res.data.ind_scientific_dissertation
            this.research.ind_solve_tech_problem      = res.data.ind_solve_tech_problem
            this.research.ind_feasibility_study       = res.data.ind_feasibility_study
            this.research.ind_other                   = res.data.ind_other
            this.research.other_purpose               = res.data.other_purpose
            this.research.notes = res.data.notes
            this.research.research_digital_patents = res.data.research_digital_patents
            this.research.search_period_type_code = res.data.search_period_type_code
            this.research.research_type_code = res.data.research_type_code
            this.research.id_card_file_key = res.data.id_card_file_key
            this.research.id_card_file_name = res.data.id_card_file_name

            if (this.research.ind_lang_arabic === 'Y') this.indLang.push('ind_lang_arabic')
            if (this.research.ind_lang_english === 'Y') this.indLang.push('ind_lang_english')
            if (this.research.ind_lang_french === 'Y') this.indLang.push('ind_lang_french')
            if (this.research.ind_lang_german === 'Y') this.indLang.push('ind_lang_german')
            if (this.research.ind_lang_other === 'Y') this.indLang.push('ind_lang_other')

            if (this.research.ind_search_egyptian === 'Y') this.indSearch.push('ind_search_egyptian')
            if (this.research.ind_search_foreign === 'Y') this.indSearch.push('ind_search_foreign')

            if (this.research.ind_to_start === 'Y') this.indPurpose.push('ind_to_start')
            if (this.research.ind_scientific_dissertation === 'Y') this.indPurpose.push('ind_scientific_dissertation')
            if (this.research.ind_solve_tech_problem === 'Y') this.indPurpose.push('ind_solve_tech_problem')
            if (this.research.ind_feasibility_study === 'Y') this.indPurpose.push('ind_feasibility_study')
            if (this.research.ind_other === 'Y') this.indPurpose.push('ind_other')
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetResearchService()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnAddPatent(){
      this.$refs.patentInfo.validate().then((valid) => {
        if(valid){
          let patent = {
            patent_no : this.patentNumber,
            country_code : this.countryCode
          }
          this.research.research_digital_patents.push(patent)
          this.patentNumber = ''
          this.countryCode = ''

          requestAnimationFrame(() => {
            this.$refs.patentInfo.reset()
          })
        }else{
          if(utils.isNull(this.patentNumber)){
            this.$refs.patent_number.focus()
          }else if(utils.isNull(this.countryCode)){
            this.$refs.country.focus()
          }
        }
      })
    },
    fnDelPatent(index){
      this.research.research_digital_patents.splice(index, 1)
    },
    fnInitDigitalFile() {
      this.digitalDocFile = null
      this.research.digital_doc_file_key = ''
      this.research.digital_doc_file_name = ''
    },

    fnUploadDigitalFile(){
      if(!utils.isNull(this.digitalDocFile)){
        let extList = []
        extList.push({name_en: 'doc'})
        extList.push({name_en: 'docx'})

        if (utils.getFileExtLen(this.digitalDocFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.digitalDocFile = null
            this.research.digital_doc_file_key = ''
            this.research.digital_doc_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.digitalDocFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.research.digital_doc_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadDigitalFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.digitalDocFile = null
                this.research.digital_doc_file_key = ''
                this.research.digital_doc_file_name = ''
              }
            }
          }
        })
      }
    },
    fnInitIdCardFile() {
      this.idCardFile = null
      this.research.id_card_file_key = ''
      this.research.id_card_file_name = ''
    },
    fnUploadIdCardFile() {
      if(!utils.isNull(this.idCardFile)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.idCardFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.idCardFile = null
            this.research.id_card_file_key = ''
            this.research.id_card_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.idCardFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.research.id_card_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadIdCardFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.idCardFile = null
                this.research.id_card_file_key = ''
                this.research.id_card_file_name = ''
              }
            }
          }
        })
      }
    },
    fnNext(){
      this.$refs.researchService1.validate().then((valid1) => {
        this.$refs.researchService2.validate().then((valid2) => {
          if (valid1 && valid2) {
            this.fnSaveContent()
          } else {
            document.getElementsByClassName('error--text')[0].scrollIntoView(false)
          }
        })
      })
    },
    fnSaveContent(){
      this.research.ind_feasibility_study       = utils.isNull(this.research.ind_feasibility_study      ) ? 'N' : this.research.ind_feasibility_study
      this.research.ind_lang_arabic = utils.isNull(this.research.ind_lang_arabic) ? 'N': this.research.ind_lang_arabic
      this.research.ind_lang_english            = utils.isNull(this.research.ind_lang_english           ) ? 'N' : this.research.ind_lang_english
      this.research.ind_lang_french             = utils.isNull(this.research.ind_lang_french            ) ? 'N' : this.research.ind_lang_french
      this.research.ind_lang_german             = utils.isNull(this.research.ind_lang_german            ) ? 'N' : this.research.ind_lang_german
      this.research.ind_lang_other              = utils.isNull(this.research.ind_lang_other             ) ? 'N' : this.research.ind_lang_other
      this.research.ind_other                   = utils.isNull(this.research.ind_other                  ) ? 'N' : this.research.ind_other
      this.research.ind_scientific_dissertation = utils.isNull(this.research.ind_scientific_dissertation) ? 'N' : this.research.ind_scientific_dissertation
      this.research.ind_search_egyptian         = utils.isNull(this.research.ind_search_egyptian        ) ? 'N' : this.research.ind_search_egyptian
      this.research.ind_search_foreign          = utils.isNull(this.research.ind_search_foreign         ) ? 'N' : this.research.ind_search_foreign
      this.research.ind_solve_tech_problem      = utils.isNull(this.research.ind_solve_tech_problem     ) ? 'N' : this.research.ind_solve_tech_problem
      this.research.ind_to_start                = utils.isNull(this.research.ind_to_start               ) ? 'N' : this.research.ind_to_start

      this.research.company_name_ar = this.applicant.company_name_ar

      if (this.research.research_type_code !== '5807') {
        this.research.id_card_file_key = ''
      }

      requestApi({
        url: '/receivings/research/' + this.receipt_no,
        method: 'PUT',
        data : this.research,
        callback: (res) => {
          if (res.res_code === '200') {
            this.fnSaveDocuments()
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSaveContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAttachDocList(){
      requestApi({
        url: '/receivings/' + this.receipt_no + '/documents',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.attachDocList = res.data.list
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAttachDocList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnSaveDocuments(){
      requestApi({
        url: '/receivings/research/' + this.receipt_no + '/documents',
        method: 'PUT',
        data: this.attachDocList,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.$router.push({path : '/public/research/step2/'+this.receipt_no})
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSaveDocuments()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.error_msg = this.$vuetify.rtl ? res.res_msg_en : res.res_msg_ar
            }
          }
        }
      })
    },
    fnGetCompanyName(rtl){
      let company_name = ''
      if(rtl){
        if(utils.isNull(this.applicant.company_name_ar)){
          if(utils.isNull(this.applicant.company_name_en)){
            company_name = this.research.company_name_ar
          }else{
            company_name = this.applicant.company_name_en
          }
        }else{
          company_name = this.applicant.company_name_ar
        }
      }else{
        if(utils.isNull(this.applicant.company_name_en)){
          if(utils.isNull(this.applicant.company_name_ar)){
            company_name = this.research.company_name_ar
          }else{
            company_name = this.applicant.company_name_ar
          }
        }else{
          company_name = this.applicant.company_name_en
        }
      }
      return company_name
    },
    fnValidateComment(value) {
      return this.$t('public.research_service.fields.comment_words_msg', {words : value.length})
    },
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6417'
              || res.data.receipt_status_type_code !== '4301') {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
  }
}
</script>
<style scoped>
  .request_data_name {
    font-size: 12px !important;
    color: #222222 !important;
    font-weight: 700;
    padding: 10px 20px;
  }
  .reques_data_value {
    font-size: 12px !important;
    color: #444 !important;
    font-weight: 300;
  }
  .input_text_type_basic.file_type > div:nth-of-type(odd) {
    float:none;
  }
</style>